const module = { name: 'shared/desktop/marketingSpotlight', exports: {} }; const exports = module.exports;



import { Fandango_queryUtil as Fandango_queryUtil_getParam } from 'require-core';

const { getParam } = Fandango_queryUtil_getParam;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const Selectors = {
    CONTAINER: '#marketing-spotlight-merch-unit'
}


const Styles = {
    HIDE: 'hide'
}


const QueryParams = {
    TOKEN: 'previewToken',
    PLACEMENTS: 'preview',
    TARS_PLACEMENTS: 'tars?preview'
}


const MerchandisingUnitTypes = {
    CUSTOM: 'Custom',
    NONE: 'Placeholder/Blank',
    STANDARD: 'Standard',
}
function addPreviewTokens(queryParams) {
    const token = getParam(QueryParams.TOKEN);
    const items = getParam(QueryParams.PLACEMENTS) || getParam(QueryParams.TARS_PLACEMENTS);
    if (!token || !items) {
        return queryParams;
    }
    return Object.assign(queryParams || {}, {
        [QueryParams.TOKEN]: token,
        [QueryParams.PLACEMENTS]: items,
    });
}
function onDone(data) {
    if (!data) {
        return;
    }
    const { type } = data;
    let html = null;
    switch (type) {
        case MerchandisingUnitTypes.CUSTOM:
            html = data.markup;
            break;
        case MerchandisingUnitTypes.STANDARD:
            {
                const { imageURL, destinationURL } = data;
                html = imageURL && destinationURL && swig.render('_marketingSpotlight', data);
            }
            break;
    }
    if (html) {
        $(Selectors.CONTAINER)
            .append(html)
            .removeClass(Styles.HIDE);
    }
}
function onFail(err) {
    debugLog.warn(module.name, 'API Fail', err);
}
function init() {
    const $container = $(Selectors.CONTAINER);
    const data = {
        id: $container.data('id') || null,
        name: $container.data('name') || null,
        slot: $container.data('slot') || null,
    };
    const url = links.napiMarketingSpotlight(null, addPreviewTokens());
    xhr.ajax({
        method: 'GET',
        url,
        data
    })
        .done(onDone)
        .fail(onFail);
}
module.exports = {
    init,
};
export default module.exports;